// Auth Actions
export const LOGIN_BEGIN = 'LOGIN_BEGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const REGISTER_BEGIN = 'REGISTER_BEGIN'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'REGISTER_FAILURE'

export const VERIFY_AUTH_COOKIE_BEGIN = 'VERIFY_AUTH_COOKIE_BEGIN'
export const VERIFY_AUTH_COOKIE_SUCCESS = 'VERIFY_AUTH_COOKIE_SUCCESS'
export const VERIFY_AUTH_COOKIE_FAILURE = 'VERIFY_AUTH_COOKIE_FAILURE'

export const RECONNECT_BEGIN = 'RECONNECT_BEGIN'
export const RECONNECT_SUCCESS = 'RECONNECT_SUCCESS'
export const RECONNECT_FAILURE = 'RECONNECT_FAILURE'

export const SET_DISCONNECT = 'SET_DISCONNECT'

export const LOGOUT_BEGIN = 'LOGOUT_BEGIN'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'

export const SET_DARK_MODE = 'SET_DARK_MODE'

// Drawer Actions
export const DRAWER_TOGGLE = 'DRAWER_TOGGLE'
export const DRAWER_COLLAPSE = 'DRAWER_COLLAPSE'

// Plans Actions
export const GET_ALL_PLANS_BEGIN = 'GET_ALL_PLANS_BEGIN'
export const GET_ALL_PLANS_SUCCESS = 'GET_ALL_PLANS_SUCCESS'
export const GET_ALL_PLANS_FAILURE = 'GET_ALL_PLANS_FAILURE'

export const GET_PLAN_BEGIN = 'GET_PLAN_BEGIN'
export const GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS'
export const GET_PLAN_FAILURE = 'GET_PLAN_FAILURE'

export const POST_PLAN_BEGIN = 'POST_PLAN_BEGIN'
export const POST_PLAN_SUCCESS = 'POST_PLAN_SUCCESS'
export const POST_PLAN_FAILURE = 'POST_PLAN_FAILURE'

export const PUT_PLAN_BEGIN = 'PUT_PLAN_BEGIN'
export const PUT_PLAN_SUCCESS = 'PUT_PLAN_SUCCESS'
export const PUT_PLAN_FAILURE = 'PUT_PLAN_FAILURE'

export const DELETE_PLAN_BEGIN = 'DELETE_PLAN_BEGIN'
export const DELETE_PLAN_SUCCESS = 'DELETE_PLAN_SUCCESS'
export const DELETE_PLAN_FAILURE = 'DELETE_PLAN_FAILURE'

// Plan Groups Actions
export const GET_ALL_PLAN_GROUPS_BEGIN = 'GET_ALL_PLAN_GROUPS_BEGIN'
export const GET_ALL_PLAN_GROUPS_SUCCESS = 'GET_ALL_PLAN_GROUPS_SUCCESS'
export const GET_ALL_PLAN_GROUPS_FAILURE = 'GET_ALL_PLAN_GROUPS_FAILURE'

export const GET_PLAN_GROUP_BEGIN = 'GET_PLAN_GROUP_BEGIN'
export const GET_PLAN_GROUP_SUCCESS = 'GET_PLAN_GROUP_SUCCESS'
export const GET_PLAN_GROUP_FAILURE = 'GET_PLAN_GROUP_FAILURE'

export const POST_PLAN_GROUP_BEGIN = 'POST_PLAN_GROUP_BEGIN'
export const POST_PLAN_GROUP_SUCCESS = 'POST_PLAN_GROUP_SUCCESS'
export const POST_PLAN_GROUP_FAILURE = 'POST_PLAN_GROUP_FAILURE'

export const PUT_PLAN_GROUP_BEGIN = 'PUT_PLAN_GROUP_BEGIN'
export const PUT_PLAN_GROUP_SUCCESS = 'PUT_PLAN_GROUP_SUCCESS'
export const PUT_PLAN_GROUP_FAILURE = 'PUT_PLAN_GROUP_FAILURE'

export const DELETE_PLAN_GROUP_BEGIN = 'DELETE_PLAN_GROUP_BEGIN'
export const DELETE_PLAN_GROUP_SUCCESS = 'DELETE_PLAN_GROUP_SUCCESS'
export const DELETE_PLAN_GROUP_FAILURE = 'DELETE_PLAN_GROUP_FAILURE'

// Companies Actions
export const GET_COMPANY_BEGIN = 'GET_COMPANY_BEGIN'
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS'
export const GET_COMPANY_FAILURE = 'GET_COMPANY_FAILURE'

export const CLEAN_COMPANY = 'CLEAN_COMPANY'

// Application Services Actions
export const GET_ALL_APPLICATION_SERVICES_BEGIN = 'GET_ALL_APPLICATION_SERVICES_BEGIN'
export const GET_ALL_APPLICATION_SERVICES_SUCCESS = 'GET_ALL_APPLICATION_SERVICES_SUCCESS'
export const GET_ALL_APPLICATION_SERVICES_FAILURE = 'GET_ALL_APPLICATION_SERVICES_FAILURE'

export const POST_APPLICATION_SERVICE_BEGIN = 'POST_APPLICATION_SERVICE_BEGIN'
export const POST_APPLICATION_SERVICE_SUCCESS = 'POST_APPLICATION_SERVICE_SUCCESS'
export const POST_APPLICATION_SERVICE_FAILURE = 'POST_APPLICATION_SERVICE_FAILURE'

// Access Keys Actions
export const GET_ALL_ACCESS_KEYS_BEGIN = 'GET_ALL_ACCESS_KEYS_BEGIN'
export const GET_ALL_ACCESS_KEYS_SUCCESS = 'GET_ALL_ACCESS_KEYS_SUCCESS'
export const GET_ALL_ACCESS_KEYS_FAILURE = 'GET_ALL_ACCESS_KEYS_FAILURE'

export const GET_ACCESS_KEY_BEGIN = 'GET_ACCESS_KEY_BEGIN'
export const GET_ACCESS_KEY_SUCCESS = 'GET_ACCESS_KEY_SUCCESS'
export const GET_ACCESS_KEY_FAILURE = 'GET_ACCESS_KEY_FAILURE'

export const POST_ACCESS_KEY_BEGIN = 'POST_ACCESS_KEY_BEGIN'
export const POST_ACCESS_KEY_SUCCESS = 'POST_ACCESS_KEY_SUCCESS'
export const POST_ACCESS_KEY_FAILURE = 'POST_ACCESS_KEY_FAILURE'

export const PUT_ACCESS_KEY_BEGIN = 'PUT_ACCESS_KEY_BEGIN'
export const PUT_ACCESS_KEY_SUCCESS = 'PUT_ACCESS_KEY_SUCCESS'
export const PUT_ACCESS_KEY_FAILURE = 'PUT_ACCESS_KEY_FAILURE'

export const GET_SCORE_METRICS_BEGIN = 'GET_SCORE_METRICS_BEGIN'
export const GET_SCORE_METRICS_SUCCESS = 'GET_SCORE_METRICS_SUCCESS'
export const GET_SCORE_METRICS_FAILURE = 'GET_SCORE_METRICS_FAILURE'

export const GET_UNIQUE_DOCUMENTS_BEGIN = 'GET_UNIQUE_DOCUMENTS_BEGIN'
export const GET_UNIQUE_DOCUMENTS_SUCCESS = 'GET_UNIQUE_DOCUMENTS_SUCCESS'
export const GET_UNIQUE_DOCUMENTS_FAILURE = 'GET_UNIQUE_DOCUMENTS_FAILURE'

export const GET_SCORE_BY_DOCUMENT_BEGIN = 'GET_SCORE_BY_DOCUMENT_BEGIN'
export const GET_SCORE_BY_DOCUMENT_SUCCESS = 'GET_SCORE_BY_DOCUMENT_SUCCESS'
export const GET_SCORE_BY_DOCUMENT_FAILURE = 'GET_SCORE_BY_DOCUMENT_FAILURE'

export const GET_LOGS_BY_DOCUMENT_BEGIN = 'GET_LOGS_BY_DOCUMENT_BEGIN'
export const GET_LOGS_BY_DOCUMENT_SUCCESS = 'GET_LOGS_BY_DOCUMENT_SUCCESS'
export const GET_LOGS_BY_DOCUMENT_FAILURE = 'GET_LOGS_BY_DOCUMENT_FAILURE'

export const CLEAN_SCORE_METRICS = 'CLEAN_SCORE_METRICS'

export const GET_ALL_ACCESS_CREDENTIALS_BEGIN = 'GET_ALL_ACCESS_CREDENTIALS_BEGIN'
export const GET_ALL_ACCESS_CREDENTIALS_SUCCESS = 'GET_ALL_ACCESS_CREDENTIALS_SUCCESS'
export const GET_ALL_ACCESS_CREDENTIALS_FAILURE = 'GET_ALL_ACCESS_CREDENTIALS_FAILURE'